import InputText from "components/shared/InputText";
import InputSelectWrapper from "components/shared/InputSelectWrapper";
import InputCheckbox from "components/shared/InputCheckbox";
import InputTextArea from "components/shared/InputTextArea";
import InputFile from "components/shared/InputFile";
import InputFileMultiple from "components/shared/InputFileMultiple";
import InputNestedSelect from "components/shared/InputNestedSelect";
import InputDatePicker from "components/shared/InputDatePicker";
import Paragraph from "components/shared/Paragraph";
import Title from "components/shared/Title";

const AdditionalField = (props) => {
	let field = null;
	switch (props.type) {
		case "text":
			field = <InputText {...props} />;
			break;
		case "select":
			field = <InputSelectWrapper {...props} />;
			break;
		case "checkbox":
			field = <InputCheckbox {...props} />;
			break;
		case "textarea":
			field = <InputTextArea {...props} />;
			break;
		case "file":
			field = props.useHyperionTheme ? (
				<InputFileMultiple {...props} />
			) : (
				<InputFile {...props} />
			);
			break;
		case "nestedSelect":
			field = <InputNestedSelect {...props} />;
			break;
		case "date":
			field = <InputDatePicker {...props} />;
			break;
		case "paragraph":
			field = <Paragraph {...props} />;
			break;
		case "heading":
			field = <Title {...props} />;
			break;
		default:
			field = null;
	}
	return field;
};

export default AdditionalField;
